import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import Prereg from './views/Prereg.vue'
import privacy_policy from "./views/Privacy_policy.vue"
import money_settlement from "./views/Money_settlement.vue"
import specific_business from "./views/Specific_business"
import Policy from "./views/Policy.vue"

Vue.use(Router)

export default new Router({
	mode: process.env.NODE_ENV == 'development' ? 'hash' : 'history',
	// base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		/* {
			path: '/pre_registration',
			name: 'prereg',
			component: Prereg
		}, */
		{
			path: '/policy',
			name: 'policy',
			component: Policy
		},
		{
			path: '/privacy_policy',
			name: 'privacy_policy',
			component: privacy_policy
		},
		{
			path: '/money_settlement',
			name: 'money_settlement',
			component: money_settlement
		},
		{
			path: '/specific_business',
			name: 'specific_business',
			component: specific_business
		}
	]
})
